import { Badge } from "@/components/ui/badge";
import { Zap, CheckCircle2 } from "lucide-react";

interface ArtisanBadgesProps {
  isReactiveBadge?: boolean;
  profileCompletionScore?: number;
  responseRate?: number;
  avgResponseTimeMinutes?: number;
  lastLoginAt?: string;
  totalConversations?: number;
}

export const getActivityLabel = (lastLoginAt?: string) => {
  if (!lastLoginAt) return null;
  const diff = Date.now() - new Date(lastLoginAt).getTime();
  const days = diff / (1000 * 60 * 60 * 24);
  if (days < 1) return "Actif aujourd'hui";
  if (days < 7) return "Actif cette semaine";
  return "Actif il y a plus d'une semaine";
};

export const getActivityColor = (lastLoginAt?: string) => {
  if (!lastLoginAt) return "text-muted-foreground";
  const diff = Date.now() - new Date(lastLoginAt).getTime();
  const days = diff / (1000 * 60 * 60 * 24);
  if (days < 1) return "text-accent";
  if (days < 7) return "text-warning";
  return "text-muted-foreground";
};

const ArtisanBadges = ({
  isReactiveBadge,
  profileCompletionScore,
  responseRate,
  avgResponseTimeMinutes,
  totalConversations,
}: ArtisanBadgesProps) => {
  return (
    <div className="flex flex-wrap gap-1.5">
      {isReactiveBadge && (
        <Badge className="bg-accent/10 text-accent border-accent/20 text-xs gap-1">
          <Zap className="h-3 w-3" />
          Artisan réactif
        </Badge>
      )}
      {profileCompletionScore !== undefined && profileCompletionScore >= 100 && (
        <Badge className="bg-primary/10 text-primary border-primary/20 text-xs gap-1">
          <CheckCircle2 className="h-3 w-3" />
          Profil complet
        </Badge>
      )}
    </div>
  );
};

export const ArtisanSignals = ({
  responseRate,
  avgResponseTimeMinutes,
  totalConversations,
  lastLoginAt,
}: {
  responseRate?: number;
  avgResponseTimeMinutes?: number;
  totalConversations?: number;
  lastLoginAt?: string;
}) => {
  const activityLabel = getActivityLabel(lastLoginAt);
  const activityColor = getActivityColor(lastLoginAt);
  const showResponseTime = totalConversations !== undefined && totalConversations >= 5;

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
      {activityLabel && (
        <span className={activityColor}>● {activityLabel}</span>
      )}
      {responseRate !== undefined && responseRate > 0 && (
        <span>Répond à {Math.round(responseRate)}% des demandes</span>
      )}
      {showResponseTime && avgResponseTimeMinutes !== undefined && avgResponseTimeMinutes > 0 && (
        <span>
          Répond en moyenne en{" "}
          {avgResponseTimeMinutes < 60
            ? `${Math.round(avgResponseTimeMinutes)} min`
            : `${Math.round(avgResponseTimeMinutes / 60)}h`}
        </span>
      )}
    </div>
  );
};

export default ArtisanBadges;
